import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export type PaginationProps = {
  /** 1-indexed page number */
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination = (props: PaginationProps) => {
  const { page, totalPages, onPageChange } = props;

  return (
    <div className="flex w-full items-center justify-between px-2 py-2">
      <div className="flex w-full items-center justify-center gap-x-4">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page === 1}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-xs text-gray-400">
          Page <b>{page}</b> of <b>{totalPages}</b>
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
